import { useState } from "react";
import { ExternalLink } from "lucide-react";

const norm = (s) => (s || "").toLowerCase().replace(/[^a-z ]/g, "").trim();

export const findReferrerBookings = (name, bookings, excludeId) => {
  const n = norm(name);
  if (!n) return [];
  const [first] = n.split(" ");
  return bookings
    .filter((b) => b.id !== excludeId && b.status !== "denied")
    .filter((b) => { const f = norm(b.full_name); return f === n || (n.includes(" ") && f.includes(n)) || (!n.includes(" ") && f.startsWith(first + " ")); })
    .sort((a, b) => (b.created_at || "").localeCompare(a.created_at || ""));
};

export function ReferrerLink({ name, bookings = [], excludeId, onSelect, testId = "referrer-link" }) {
  const [open, setOpen] = useState(false);
  const matches = findReferrerBookings(name, bookings, excludeId);
  if (!matches.length) {
    return <span data-testid={`${testId}-none`}><strong>{name}</strong> <span className="text-xs" style={{ color: "var(--pp-text-muted)" }}>(no booking found)</span></span>;
  }
  if (matches.length === 1) {
    return (
      <span role="button" tabIndex={0} data-testid={testId} onClick={(e) => { e.stopPropagation(); onSelect(matches[0]); }} className="cursor-pointer inline-flex items-center gap-1 underline underline-offset-2 font-semibold" style={{ color: "var(--pp-terracotta)" }} title={`Open ${matches[0].reference}`}>
        {name} <ExternalLink className="h-3 w-3" />
      </span>
    );
  }
  return (
    <span className="relative inline-block">
      <span role="button" tabIndex={0} data-testid={testId} onClick={(e) => { e.stopPropagation(); setOpen((o) => !o); }} className="cursor-pointer inline-flex items-center gap-1 underline underline-offset-2 font-semibold" style={{ color: "var(--pp-terracotta)" }}>
        {name} <span className="text-xs">({matches.length} bookings)</span>
      </span>
      {open && (
        <ul data-testid={`${testId}-picker`} className="absolute left-0 top-full mt-1 z-20 min-w-[280px] border shadow-md text-sm" style={{ borderColor: "var(--pp-border)", backgroundColor: "var(--pp-cream-card)" }}>
          {matches.map((m) => (
            <li key={m.id}>
              <span role="button" tabIndex={0} data-testid={`${testId}-option-${m.reference}`} onClick={(e) => { e.stopPropagation(); setOpen(false); onSelect(m); }} className="cursor-pointer block w-full text-left px-3 py-2 hover:bg-[var(--pp-cream)]">
                {m.full_name} · {m.reference} · {m.date}
              </span>
            </li>
          ))}
        </ul>
      )}
    </span>
  );
}
